module.exports = __webpack_public_path__ + "static/media/help-icon.43bda397.svg";